var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandtime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 3.28125H24.2188C24.6502 3.28125 25 2.91395 25 2.46094V0.820312C25 0.367295 24.6502 0 24.2188 0H0.78125C0.349805 0 0 0.367295 0 0.820312V2.46094C0 2.91395 0.349805 3.28125 0.78125 3.28125H1.04167C1.04167 8.78856 3.13724 14.6157 7.36849 17.5C3.11842 20.3971 1.04167 26.2432 1.04167 31.7188H0.78125C0.349805 31.7188 0 32.086 0 32.5391V34.1797C0 34.6327 0.349805 35 0.78125 35H24.2188C24.6502 35 25 34.6327 25 34.1797V32.5391C25 32.086 24.6502 31.7188 24.2188 31.7188H23.9583C23.9583 26.2114 21.8628 20.3843 17.6315 17.5C21.8816 14.6029 23.9583 8.75684 23.9583 3.28125ZM4.16667 3.28125H20.8333C20.8333 10.2279 17.1024 15.8594 12.5 15.8594C7.89759 15.8594 4.16667 10.228 4.16667 3.28125ZM20.8333 31.7188H4.16667C4.16667 24.7721 7.89766 19.1406 12.5 19.1406C17.1023 19.1406 20.8333 24.7721 20.8333 31.7188Z",
    fill: "#FC947E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandtime);
export default __webpack_public_path__ + "static/media/sandtime.5ef7ac5759bd9ef1c61ab7671f99d65d.svg";
export { ForwardRef as ReactComponent };